export default "__VITE_ASSET__9671608d__"